export function validateDataForFields(data) {
   

  if(data&&data!=""&&data!=undefined)
  {
      return data 
  }
  else{

      return undefined
  }
}

export const createDropdownValues = (data) => {
  let res = [];
  if (data && data.length > 0) {
    data.map((each) => {
      res.push({ option: each, value: each });
    });
  }

  return res;
};

export const createDropdownValuesNative = (data) => {
  let res = [];
  if (data && data.length > 0) {
    data.map((each) => {
      res.push({ label: each, value: each });
    });
  }

  return res;
};

export const getKeysOfObject = (object) => {
  if (object) {
    return Object.keys(object);
  } else {
    return [];
  }
};